import React from 'react';

const Tecnologias = () => {
    return ( 
        <div className="contenedor">
            <div className="resumen">
                <span className="resumenspan"></span>
                <h5 className="titulo">Tecnologias Empleadas</h5>
                <span className="resumenspan"></span>
            </div>
            <div className="tecnologias">
                <p className="cuerpo iconos"> Python   </p>
                <p className="cuerpo iconos"> C++ </p>
                <p className="cuerpo iconos"> Matlab  </p>
                <p className="cuerpo iconos"> MySQL  </p>
                <p className="cuerpo iconos"> ArcGis  </p>
                <p className="cuerpo iconos"> PostgreSQL  </p>


            </div>
        </div>
     );
}
 
export default Tecnologias;